import * as React from 'react';
import Button from '@telia-front/button';
import { ClickArea, ClickAreaTrigger } from '@telia-front/click-area';
import Icon from '@telia-front/icon';
import Tag from '@telia-front/tag';
const Notification = (props) => {
    const { children, id, type: propType = 'info', time, isSeen, tag, button, className } = props;
    const type = normalizeType(propType);
    const BEM = () => {
        const classArray = ['notification', `notification--${type}`];
        if (!isSeen) {
            classArray.push('notification--not-seen');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getIcon = () => {
        switch (type) {
            case 'error':
                return '#alert';
            case 'success':
                return '#check-round';
            case 'attention':
                return '#alert-round';
            case 'info':
            default:
                return '#info-round';
        }
    };
    return (React.createElement(ClickArea, null,
        React.createElement("div", { className: BEM(), id: id },
            React.createElement("div", { className: "notification__head" },
                !isSeen && React.createElement(Icon, { modifiers: getIcon(), className: "notification__icon" }),
                tag && React.createElement(Tag, Object.assign({}, tag, { className: "notification__tag", size: "tiny" })),
                React.createElement("time", { dateTime: time.isoTime, className: "notification__time" }, time.formattedTime)),
            React.createElement("div", { className: "notification__content" }, children),
            button && (React.createElement(ClickAreaTrigger, null,
                React.createElement(Button, Object.assign({}, button, { className: "notification__button" })))))));
};
const normalizeType = (type) => {
    if (type === 'default') {
        return 'info';
    }
    return type;
};
export default Notification;
